<ng-container *hasPermission="['LICENSES_READ', 'LICENSES_ALL','SAFESTREET_ADMIN']">
  <div class="container-fluid">
    <div class="page-title">
      <h2>
        Dettaglio licenza - <b>{{ detail_title }}</b>
      </h2>
    </div>
    <form name="organizationForm" #f="ngForm" (ngSubmit)="onSubmit(f)">
      <div class="row">
        <div class="col-md-6">
          <label for="name" class="form-label">Name</label>
          <input type="text" class="form-control" id="name" name="name" ngModel #name="ngModel"
            [(ngModel)]="license.name" required />
        </div>
        <div class="col-md-6">
          <label for="name" class="form-label">Tipologia</label>
          <select class="form-select" aria-label="Tipo" id="type" name="type" [(ngModel)]="license.type" required>
            <option selected value=""></option>
            <option *ngFor="let licenseType of licenseTypes" [value]="licenseType.id">
              {{licenseType.description}}</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label for="enabled" class="form-label">Attiva</label>
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" id="enabled" role="switch" name="enabled" ngModel
              #enabled="ngModel" [(ngModel)]="license.enabled" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label for="duration" class="form-label">Durata (in mesi)</label>
          <input type="text" class="form-control" id="duration" name="duration" ngModel #duration="ngModel"
            [(ngModel)]="license.configuration.duration" required />
        </div>
        <div class="col-md-6">
          <label for="noticeNumberLimit" class="form-label">#Atti (0 = illimitati)</label>
          <input type="text" class="form-control" id="noticeNumberLimit" name="noticeNumberLimit" ngModel
            #noticeNumberLimit="ngModel" [(ngModel)]="license.configuration.noticeNumberLimit" required />
        </div>
      </div>
      <div class="row" *ngIf="license.type === 'USER'">
        <div class="col-md-6">
          <div class="auto-complete">
            <label for="accountUsername" class="form-label">Account</label>
            <input type="text" class="form-control" id="accountUsername" name="accountUsername" ngModel
              [(ngModel)]="accountUsername" (keyup)="onAccountKeyUp($event)"
              pattern="{{accountPatternValidation}}" required />
            <ul *ngIf="accounts && accounts.length>0">
              <li *ngFor="let account of accounts" (click)="selectAccount(account)">
                {{account.username}}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="license.type === 'DEVICE'">
        <div class="col-md-6">
          <div class="auto-complete">
            <label for="deviceName" class="form-label">Dispositivo</label>
            <input type="text" class="form-control" id="deviceName" name="deviceName" ngModel
              [(ngModel)]="deviceName" (keyup)="onDeviceKeyUp($event)"
              pattern="{{devicePatternValidation}}" required />
            <ul *ngIf="devices && devices.length>0">
              <li *ngFor="let device of devices" (click)="selectDevice(device)">
                {{device.name}}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="form-label d-block">Moduli attivi</label>
          <div class="form-check form-check-inline" *ngFor="let module of licenseModules">
            <input class="form-check-input" type="checkbox" [id]="'module_' + module.id"
              [checked]="isModuleActive(module.id)" (change)="toggleModule(module.id)"
              [disabled]="module.id === 'USE_EXTERNAL_CAMERA' && !isExternalCameraAvailable()" />
            <label class="form-check-label" [for]="'module_' + module.id">{{module.description}}</label>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end align-items-center mt-2 gap-2">
        <button type="button" class="btn btn-outline-secondary" (click)="back()">
          Indietro
        </button>
        <ng-template [hasPermission]="['LICENSES_DELETE', 'LICENSES_ALL','SAFESTREET_ADMIN']">
          @if (license.id !== undefined) {
          <button type="button" (click)="confirmDelete()" class="btn btn-danger">
            Elimina
          </button>
          }
        </ng-template>
        <ng-template [hasPermission]="['LICENSES_UPDATE', 'LICENSES_ALL','SAFESTREET_ADMIN']">
          @if (license.id !== undefined) {

          <button type="submit" class="btn btn-primary">
            Salva
          </button>
          }
        </ng-template>
        <ng-template [hasPermission]="['LICENSES_CREATE', 'LICENSES_ALL','SAFESTREET_ADMIN']">
          @if (license.id === undefined) {
          <button type="submit" class="btn btn-primary">
            Salva
          </button>
          }

        </ng-template>
      </div>
    </form>
    <app-confirm-alert [confirmationMessage]="'Eliminazione licensa - ' + confirmationMessage"
      [showConfirmationModal]="showConfirmationModal" (modalConfirm)="delete()" (modalCancel)="cancelDelete()">
    </app-confirm-alert>
  </div>
</ng-container>